import { Icon, Image } from '@cue/atoms';
import { useResponsive } from '@cue/hooks';
import { Modal, useModal } from '@cue/organisms';
import { Global } from '@emotion/react';
import { getTranslationsForLanguage, parseGatsbyImage } from '@project/cms/pre-hooks';
import React from 'react';

import { useTranslation } from 'react-i18next';

export const AdditionalLocationsCardDeck: React.FC<
  CMS_Additional_Locations_Card_Deck_Module_Data
> = (props) => {
  const { i18n } = useTranslation();
  const cards = props.cards.map((card) => getTranslationsForLanguage(card, i18n.language));

  return (
    <div className="cue-additional-locations-card-deck">
      {cards.map((card) => (
        <AdditionalLocationsCard key={card.id} {...card} />
      ))}
    </div>
  );
};

export const AdditionalLocationsCard: React.FC<
  CMS_Additional_Locations_Card_Deck_Module_Data['cards'][0]
> = (props) => {
  const { headline, subline, show_logo, modal_image, mobile_image } = props;
  const desktopImage = modal_image ? parseGatsbyImage(modal_image) : null;
  const mobileImage = mobile_image ? parseGatsbyImage(mobile_image) : null;
  const [cardModal] = useModal();
  const [showMobileImage, setShowMobileImage] = React.useState(false);
  const { isMobile } = useResponsive();

  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1000) {
        setShowMobileImage(true);
      } else {
        setShowMobileImage(false);
      }
    };
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={`cue-additional-locations-card cue-additional-locations-card--clickable`}>
      <div
        className="cue-additional-locations-card__content"
        onClick={() => cardModal.current?.open()}>
        {show_logo ? <div className="cue-project-brand" /> : null}
        <h4 className="cue-additional-locations-card__headline">{headline}</h4>
        <p className="cue-additional-locations-card__subline">{subline}</p>
        {desktopImage ? <Icon name="arrow-right" className="arrow" /> : null}
      </div>
      <Modal
        ref={cardModal}
        overrideCSS={{
          '.cue-modal-content': {
            padding: 0,
            overFlow: 'hidden',
            maxHeight: '100%',
            '.cue-additional-locations-card__landscape-image': {
              maxHeight: 'calc(100vh - 150px)',
            },
          },
          '.cue-modal-backdrop': {
            ...(isMobile ? { padding: 0 } : {}),
            '.cue-modal-container': {
              ...(isMobile ? { padding: 0 } : {}),
            },
          },
        }}>
        {showMobileImage && mobileImage ? (
          <Image
            src={mobileImage?.src}
            alt={headline}
            className="cue-additional-locations-card__portrait-image"
          />
        ) : (
          <Image
            src={desktopImage?.src}
            alt={headline}
            className="cue-additional-locations-card__landscape-image"
          />
        )}

        <Global
          //eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          styles={{
            body: {
              overflowY: 'hidden!important',
            },
          }}
        />
      </Modal>
    </div>
  );
};
